import React from 'react';
import Icon from '../../../components/AppIcon';

const TenantMetricsStrip = () => {
  const metrics = [
    {
      id: 'total-tenants',
      title: 'Total Tenants',
      value: '2,847',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'Building2',
      description: 'Active tenant accounts'
    },
    {
      id: 'arpu',
      title: 'Average Revenue Per User',
      value: '$89.50',
      change: '+8.2%',
      changeType: 'positive',
      icon: 'DollarSign',
      description: 'Monthly ARPU'
    },
    {
      id: 'trial-conversion',
      title: 'Trial Conversion Rate',
      value: '24.8%',
      change: '-2.1%',
      changeType: 'negative',
      icon: 'TrendingUp',
      description: 'Last 30 days'
    },
    {
      id: 'renewal-forecast',
      title: 'Renewal Forecast',
      value: '92.3%',
      change: '+1.8%',
      changeType: 'positive',
      icon: 'RefreshCw',
      description: 'Next 90 days'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
      {metrics.map((metric) => (
        <div
          key={metric.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-200 dashboard-fade-in"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`
              w-12 h-12 rounded-lg flex items-center justify-center
              ${metric.changeType === 'positive' ? 'bg-success/10' : 'bg-warning/10'}
            `}>
              <Icon 
                name={metric.icon} 
                size={24} 
                color={metric.changeType === 'positive' ? 'var(--color-success)' : 'var(--color-warning)'} 
              />
            </div>
            <div className={`
              flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium
              ${metric.changeType === 'positive' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }
            `}>
              <Icon 
                name={metric.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                size={12} 
              />
              <span>{metric.change}</span>
            </div>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-text-secondary">
              {metric.title}
            </h3>
            <p className="text-3xl font-bold text-text-primary">
              {metric.value}
            </p>
            <p className="text-xs text-text-secondary">
              {metric.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TenantMetricsStrip;